import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function PricingCTA() {
  const handleCTAClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        value: 6.39,
        currency: 'USD',
        content_name: 'Blindaje 21',
        content_ids: ['47456673104121'],
        content_type: 'product'
      });
    }
    window.location.href = 'https://contratista360.com/cart/47456673104121:1';
  };
  return <section id="pricing" className="w-full bg-gradient-to-b from-blueprint-blue to-dark-gray py-16 md:py-24" data-id="element-180">
      <div className="max-w-4xl mx-auto px-4" data-id="element-181">
        {/* Main Offer */}
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden" data-id="element-182">
          {/* Header */}
          <div className="bg-safety-yellow text-dark-gray text-center py-6" data-id="element-183">
            <p className="font-heading text-2xl md:text-3xl" data-id="element-184">OFERTA ESPECIAL</p>
          </div>

          {/* Content */}
          <div className="p-8 md:p-12" data-id="element-185">
            <h2 className="font-heading text-4xl md:text-6xl text-blueprint-blue text-center mb-4" data-id="element-186">
              Blindaje 21
            </h2>
            <p className="text-xl md:text-2xl text-industrial-gray text-center mb-8" data-id="element-187">
              Plan de Rescate para Contratistas
            </p>

            {/* Price */}
            <div className="text-center mb-8" data-id="element-188">
              <div className="flex gap-4 mb-2 flex-col items-center justify-center" data-id="element-189">
                <span className="text-gray-400 line-through text-2xl" data-id="element-190">
                  $37.59
                </span>
                <span className="font-heading text-6xl md:text-7xl text-construction-orange" data-id="element-191">
                  $6.39
                </span>
              </div>
              <p className="text-gray-600 text-lg mb-6" data-id="element-192">
                Pago único. Sin suscripciones.
              </p>

              {/* CTA Button - Moved here, right after price */}
              <button onClick={handleCTAClick} className="cta-pulse w-full bg-safety-yellow hover:bg-yellow-500 text-dark-gray font-bold text-2xl md:text-3xl py-6 rounded-lg transition-all duration-300 transform hover:scale-105" aria-label="Obtener acceso instantáneo a Blindaje 21 por $6.39" data-id="element-193">
                OBTENER ACCESO INSTANTÁNEO POR $6.39
              </button>
            </div>

            {/* What's Included */}
            <div className="mb-8" data-id="element-194">
              <h3 className="font-heading text-2xl md:text-3xl text-blueprint-blue mb-6 text-center" data-id="element-195">
                Lo que obtienes hoy:
              </h3>
              <ul className="space-y-4" data-id="element-196">
                <li className="flex items-start gap-3" data-id="element-197">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-198" />
                  <span className="text-lg text-industrial-gray" data-id="element-199">
                    <strong data-id="element-200">PDF completo de Blindaje 21</strong> con el plan día
                    por día
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-201">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-202" />
                  <span className="text-lg text-industrial-gray" data-id="element-203">
                    <strong data-id="element-204">Guiones de WhatsApp</strong> probados para reactivar
                    clientes
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-205">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-206" />
                  <span className="text-lg text-industrial-gray" data-id="element-207">
                    <strong data-id="element-208">Sistema de Micro-Licitación</strong> paso a paso
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-209">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-210" />
                  <span className="text-lg text-industrial-gray" data-id="element-211">
                    <strong data-id="element-212">Estrategias de cierre</strong> para la primera
                    visita
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-213">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-214" />
                  <span className="text-lg text-industrial-gray" data-id="element-215">
                    <strong data-id="element-216">Plantillas listas para usar</strong> (emails,
                    mensajes, presupuestos)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-217">
                  <CheckCircleIcon className="w-6 h-6 text-safety-yellow flex-shrink-0 mt-1" aria-hidden="true" data-id="element-218" />
                  <span className="text-lg text-industrial-gray" data-id="element-219">
                    <strong data-id="element-220">Acceso inmediato</strong> - Empieza hoy mismo
                  </span>
                </li>
              </ul>
            </div>

            <p className="text-center text-gray-600 mb-8" data-id="element-221">
              Acceso instantáneo al PDF + Plan de Acción de 21 Días
            </p>

            {/* Guarantee */}
            <div className="bg-gray-50 p-6 rounded-lg border-2 border-safety-yellow" data-id="element-222">
              <div className="flex items-start gap-4" data-id="element-223">
                <ShieldCheckIcon className="w-12 h-12 text-safety-yellow flex-shrink-0" aria-hidden="true" data-id="element-224" />
                <div data-id="element-225">
                  <h4 className="font-heading text-xl md:text-2xl text-blueprint-blue mb-2" data-id="element-226">
                    Garantía de Devolución Total
                  </h4>
                  <p className="text-industrial-gray leading-relaxed" data-id="element-227">
                    Si aplicas el sistema durante 21 días y no ves resultados,
                    te devuelvo tu dinero completo. Sin preguntas. Sin letra
                    pequeña.
                  </p>
                </div>
              </div>
            </div>

            {/* Urgency */}
            <div className="mt-8 text-center" data-id="element-228">
              <div className="flex items-center justify-center gap-2 text-construction-orange mb-2" data-id="element-229">
                <ClockIcon className="w-6 h-6" aria-hidden="true" data-id="element-230" />
                <p className="font-bold text-lg" data-id="element-231">
                  El precio sube a $197 en 48 horas
                </p>
              </div>
              <p className="text-gray-600" data-id="element-232">
                No esperes a que tu calendario esté completamente vacío
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}